import permissionsMixin from '../Mixins/journey-permissions';
import resources from '../../../Util/Mixins/resources';
import snowplow from '../snowplow';
import api from '../api';
import { bootstrapDangerGrowl } from '../../../Util/growler';

import VSelect from 'vue-select';
import settingsItem from '../Components/Composer/BrickSettings/BrickSettingsContentItem.vue';

const resolvePromise = (promise, callback) => {
    promise.then(
        (result) => {
            callback(result);
        },
        bootstrapDangerGrowl
    );
};

export default {
    components: {
        VSelect,
        settingsItem
    },
    mixins: [permissionsMixin,resources],
    created() {
        const vm = this;

        //We don't want to update the property until the save button is clicked.
        vm.settings = Object.assign({}, vm.value);
        vm.newName = vm.name;
    },
    methods: {
        saveSettings() {
            snowplow.trackStructuredEvent(`changed-${this.type}-settings`);

            this.$emit('save', {
                config: this.settings,
                name: this.newName
            });
        },
        getJourneys(callback) {
            resolvePromise(api.getJourneys(), callback);
        },
        getTouchPoints(callback) {
            resolvePromise(api.getTouchpointTypes(), callback);
        },
        getAudiences(callback) {
            resolvePromise(api.getAudiences(), callback);
        }
    },
    computed: {
        type() {
            //Type is the last part of the component name. Used for snowplow event tracking.
            const nameParts = this.$options.name.split('-');
            return nameParts[nameParts.length-1];
        }
    },
    data() {
        return {
            settings: {},
            newName: ''
        };
    },
    props: {
        show: {
            type: Boolean,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        availableConditions: {
            type: Array,
            required: true
        }
    }
};